import { Theme } from '@mui/material/styles'

import { merge } from 'lodash'
import Accordion from './Accordion'
import Alert from './Alert'
import Autocomplete from './Autocomplete'
import Button from './Button'
import Chip from './Chip'
import LoadingButton from './LoadingButton'
import Form from './Form'
import Input from './Input'
import List from './List'
import Menu from './Menu'
import Pagination from './Pagination'
import Select from './Select'
import Tabs from './Tabs'
import TextField from './TextField'

// ==============================|| OVERRIDES - MAIN ||============================== //

export default function ComponentsOverrides(theme: Theme) {
  return merge(
    Accordion(theme),
    Autocomplete(),
    Alert(theme),
    Button(theme),
    LoadingButton(theme),
    Chip(theme),
    Form(theme),
    Input(theme),
    List(theme),
    Menu(theme),
    Pagination(theme),
    Select(theme),
    Tabs(theme),
    TextField(theme)
  )
}
